import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    table: {
      borderSpacing: 0,
    },
    th: {
      color: '#646464',
      fontWeight: 'bold',
    },
    tr: {
      '&>.MuiTableCell-root': {
        borderBottom: 'none !important',
      },
      '&>div>.MuiTableCell-root': {
        borderBottom: 'none !important',
      },
      cursor:'pointer'
    },
    cellSpaced:{
      justifyContent:'space-between',
    },
    cell: {
      display: 'flex',
      [theme.breakpoints.down(550)]: {
        flexDirection: 'column',
      }
    },
    img: {
      width: '76px',
      height: '62px',
      borderRadius: '13px',
      marginRight: '10px',
    },
    name: {
      color: theme.palette.primary.main,
      fontSize: '16px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    brand: {
      marginRight: '3px',
      textTransform: 'capitalize',
    },
    description: {
      color: '#C4C4C4',
      fontSize: '14px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    price: {
      color: '#646464',
      fontSize: '16px',
      fontWeight: 'bold',
    },
    priority: {
      color: '#646464',
      fontSize: '16px',
      marginLeft: '18px',
    },
    deleteButton: {
      color: '#DB0032',
    },
  })
);

export default useStyles;
